import { AttrField, BelongsToField, OrmModel, StringField } from 'vuex-orm-decorators'
import { modelNames } from '@/data/models/types'
import type { FromNumber, SessionCountry } from '@/services/domain/session/types'
import SessionShort from '@/data/models/domain/session/SessionShort'
import UserPersonalInfo from '@/data/models/domain/UserPersonalInfo'
import type { EmailToSmsMetadata } from '@/data/models/domain/types'

@OrmModel(modelNames.SESSION)
export default class Session extends SessionShort {
  @AttrField([])
  public fromNumbers: FromNumber[]

  @AttrField([])
  public countries: SessionCountry[]

  @StringField()
  public createdById: string

  @BelongsToField(UserPersonalInfo, 'createdById')
  public createdBy: UserPersonalInfo

  @AttrField()
  public archivedAt: string | null

  @AttrField()
  public emailToSms: EmailToSmsMetadata | null

  public get isArchived() {
    return this.archivedAt !== null
  }

  public get canBeArchived() {
    return !this.isArchived
  }

  public get canBeRestored() {
    return this.isArchived
  }

  public get canBeDuplicated() {
    return !this.isArchived
  }
}
